import React from 'react';
import { Box } from '@mui/material';

const HSeparator = ({ children, variant, sx, ...rest }) => (
  <Box sx={{ height: '1px', width: '100%', bgcolor: 'rgba(135, 140, 189, 0.3)', ...sx }} {...rest} />
);

const VSeparator = ({ children, variant, sx, ...rest }) => (
  <Box sx={{ width: '1px', bgcolor: 'rgba(135, 140, 189, 0.3)', ...sx }} {...rest} />
);

export { HSeparator, VSeparator };
